import styled from "@emotion/styled";
import { Colors, FontWeight, Spacing } from "@snapchat/snap-design-system";

export const LensVisibilityLabelCompactContainer = styled.div`
    display: flex;
    gap: ${Spacing.XS}px;
    align-items: center;
    justify-content: space-between;

    width: 100%;

    font-weight: ${FontWeight.NORMAL};

    .sds-tooltip-indicator {
        fill: ${Colors.Gray.V300} !important;
    }
`;

export const LensVisibilityLabelCompactIcon = styled.span`
    margin-right: ${Spacing.XS}px;
`;
